import Api from "./api";

export default {
  token(payload = {}) {
    return Api().post(`${process.env.VUE_APP_BOOKING_API || ''}/order/submit`, JSON.stringify(payload))
  },
  results(quote, modifiers = "") {
    return Api(modifiers).get(process.env.VUE_APP_AVAILABILITY_API || '', {
      params: { key: process.env.VUE_APP_AVAILABILITY_API_KEY, ...quote }
    })
  },
  reviews(id, modifiers = "") {
    return Api(modifiers).get(`${process.env.VUE_APP_REVIEWS_API || ''}?id=${id}`)
  },
  quoteCounter(quote, modifiers = "") {
    return Api(modifiers).get(process.env.VUE_APP_QUOTE_COUNTER_API || '', {
      body: quote
    })
  },
  regLookup(registration = "") {
    if(!registration) return false
    return Api().post(process.env.VUE_APP_REG_LOOKUP || '', { reg: registration }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  login(credentials) {
    return Api().post(`${process.env.VUE_APP_CUSTOMER_API || ''}/customer/authenticate`, JSON.stringify(credentials), { 
      headers: {
        AccessToken: process.env.VUE_APP_CUSTOMER_API_KEY,
        'Content-Type': 'application/json'
      }
    })
  },
  password(email) {
    return Api().post(`${process.env.VUE_APP_CUSTOMER_API || ''}/email/password/forgotten`, JSON.stringify({ email }), {
      headers: {
        AccessToken: process.env.VUE_APP_CUSTOMER_API_KEY,
        'Content-Type': 'application/json'
      }
    })
  },
  emailLookup(email = "") {
    return Api().post(`${process.env.VUE_APP_CUSTOMER_API || ''}/customer/email/check`, JSON.stringify({ email }), { 
      headers: {
        AccessToken: process.env.VUE_APP_CUSTOMER_API_KEY,
        'Content-Type': 'application/json'
      }
    })
  },
  createAccount(customer) {
    return Api().post(`${process.env.VUE_APP_CUSTOMER_API || ''}/customer/token`, JSON.stringify(customer), { 
      headers: {
        AccessToken: process.env.VUE_APP_CUSTOMER_API_KEY,
        'Content-Type': 'application/json'
      }
    })
  },
  getCustomer(token, id) {
    return Api().get(`${process.env.VUE_APP_CUSTOMER_API || ''}/customer/${id}/`, { 
      headers: {
        AccessToken: process.env.VUE_APP_CUSTOMER_API_KEY,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
  },
  mxmLookup(email = "") {
    return Api("silent").post(`${process.env.VUE_APP_MAXIMAIL_API || ''}/emailcentre/token`, JSON.stringify({ email }), { 
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  saveForLater(payload) {
    return Api().post(`${process.env.VUE_APP_MAXIMAIL_API || ''}/emailcentre/save-for-later`, JSON.stringify(payload), { 
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  revealPromo(payload) {
    return Api().post(`${process.env.VUE_APP_MAXIMAIL_API || ''}/emailcentre/activate-promo`, JSON.stringify(payload), { 
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  confirm(payload) {
    return Api("silent").get(`${process.env.VUE_APP_BOOKING_API || ''}/order/confirm${payload.amend ? '/amendment' : ''}`, { params: { id: payload.id, "cko-session-id": payload.session } })
  },
  getBooking(id) {
    return Api().get(`${process.env.VUE_APP_BOOKING_API || ''}/order`, { params: { id } })
  }
}
